import { Block, Flex, Icon } from '@aloft/toolkit-sui';

import { PROPERTY_GRID_COLUMN_WIDTH } from './consts.ts';

type ColumnErrorBoundaryFallbackProps = {
  error: Error;
  errorString: string;
};

export const ColumnErrorBoundaryFallback = ({
  error,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  errorString,
}: ColumnErrorBoundaryFallbackProps) => (
  <Flex
    flexDirection="column"
    width="100%"
    maxWidth={PROPERTY_GRID_COLUMN_WIDTH}
    height="100%"
    alignItems="center"
    justifyContent="center"
    gap="8px"
    textAlign="center"
  >
    <Icon icon="error-warning" color="alertErrorLight" size="xxl" />
    <Block __dangerDoNotUseSx={{ fontWeight: 'bold' }}>Error loading column</Block>
    <Block width="100%">{error.message}</Block>
  </Flex>
);
